/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon20Regular = forwardRef('FlagAIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 19a.75.75 0 0 0 1.5 0v-5.25H17a1 1 0 0 0 .8-1.6L14.687 8 17.8 3.85a1 1 0 0 0-.8-1.6H4A1.75 1.75 0 0 0 2.25 4v15ZM4 3.75a.25.25 0 0 0-.25.25v8.25H16l-2.85-3.8a.75.75 0 0 1 0-.9L16 3.75H4Z" })));
});
